export const ignoreErrors = [
  "Canvas is empty",
  "undefined is not an object (evaluating 'a.O')",
  "undefined is not an object (evaluating '__gCrWeb.translate.handleResponse')",
  "Loading chunk",
  "ResizeObserver loop",
  "unsupported number: NaN",
  "Loading CSS",
  "NotFoundError",
  "readableAddChunk(readable-stream/lib/_stream_readable",
  "t.cleanup(src/elements/Node)",
  /Java object is gone/,
  "undefined is not an object (evaluating 'window.webkit.messageHandlers')",
  /window\.webkit\.messageHandlers/,
  /sendDataToNative/,
  /sendPageHideMessage/,
];

export const denyUrls = [
  /iabjs:\/\//i,
  /navigation_performance_logger_android/i,
];
